import { observer } from "mobx-react";
import React, { useEffect } from "react";
import ConfigurationStore from "../../stores/ConfigurationStore";
import GlobalStore from "../../stores/GlobalStore";
import { Link } from "react-router-dom";

function ApiAccounts(props) {
  useEffect(() => {
    ConfigurationStore.getApiAccounts();
    GlobalStore.pageName = "api-accounts";
  }, []);

  const edit = (id) => {
    props.history.push(`/api-account/edit/${id}`);
  };

  const onDelete = (id) => {
    let r = window.confirm("Are you sure to delete this api account?");
    if (r) {
      ConfigurationStore.deleteApiAccount(id).then(() => {
        ConfigurationStore.getApiAccounts();
      });
    }
  };

  let { apiAccounts = [] } = ConfigurationStore;
  return (
    <React.Fragment>
      <div className="table-info">
        <table border="0" cellSpacing="0">
          <thead>
            <tr>
              <th>Name</th>
              <th>API Endpoint</th>
              <th>Client</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {apiAccounts &&
              apiAccounts.map((account) => {
                return (
                  <tr>
                    <td>{account.name}</td>
                    <td>{account.api_endpoint}</td>
                    <td>{account?.client_data[0]?.code}</td>
                    <td>
                      <button
                        className="primarybtn"
                        onClick={() => edit(account._id)}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => onDelete(account._id)}
                        className="primarybtn delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <div className="bottom-button">
          <Link to="/api-account/add">
            <button className="primarybtn add-btn">+ Add API Account</button>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
}

export default observer(ApiAccounts);
